import { jsx as _jsx } from "react/jsx-runtime";
import { useReducedMotion } from '#pplx/frontend/common/hooks/useReducedMotion.js';
import { COMPOSER_MOTION_SPRING } from '#pplx/frontend/composer-sdk/composerMotion.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { animated, useSpring } from '@react-spring/web';
import { useEffect, useMemo, useRef } from 'react';
const ARROW_UP = [
    [12, 19, 12, 5, 1],
    [12, 5, 19, 12, 1],
    [12, 5, 5, 12, 1],
    [12, 12, 12, 12, 0],
    [12, 12, 12, 12, 0],
];
const ARROW_RIGHT = [
    [5, 12, 19, 12, 1],
    [19, 12, 12, 19, 1],
    [19, 12, 12, 5, 1],
    [12, 12, 12, 12, 0],
    [12, 12, 12, 12, 0],
];
const VOICE = [
    [12, 4.5, 12, 19.5, 1],
    [16.04, 6.81, 16.04, 17.19, 1],
    [7.96, 6.81, 7.96, 17.19, 1],
    [3.92, 10.85, 3.92, 13.15, 1],
    [20.08, 10.85, 20.08, 13.15, 1],
];
function getIconMorph(icon) {
    if (icon === $icon('arrow-up'))
        return ARROW_UP;
    if (icon === $icon('arrow-right'))
        return ARROW_RIGHT;
    if (icon === $icon('custom-perplexity-v2v'))
        return VOICE;
    return undefined;
}
/** Interpolates supported decorative icons while Aether owns sizing. */
export function useComposerActionIcon(icon, isFramed) {
    const morph = isFramed ? getIconMorph(icon) : undefined;
    const previousMorph = useRef(morph);
    useEffect(() => {
        previousMorph.current = morph;
    }, [morph]);
    const reducedMotion = useReducedMotion();
    const { points } = useSpring({
        points: (morph ?? ARROW_UP).flat(),
        config: COMPOSER_MOTION_SPRING,
        immediate: reducedMotion || !morph || !previousMorph.current,
    });
    // Keep the icon component stable while the spring updates its line segments.
    // Aether still owns its size, stroke weight, and decorative semantics.
    const glyph = useMemo(() => function ActionGlyph({ size, strokeWidth, className, 'aria-hidden': ariaHidden }) {
        return (_jsx("svg", { "aria-hidden": ariaHidden, className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", children: ARROW_UP.map((_, index) => (_jsx(animated.line, { x1: points.to((...value) => value[index * 5]), y1: points.to((...value) => value[index * 5 + 1]), x2: points.to((...value) => value[index * 5 + 2]), y2: points.to((...value) => value[index * 5 + 3]), opacity: points.to((...value) => value[index * 5 + 4]) }, index))) }));
    }, [points]);
    return morph ? glyph : icon;
}
//# sourceMappingURL=useComposerActionIcon.js.map